// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__BReQW","colCheckbox":"styles_colCheckbox__3O25-"};